export default __webpack_public_path__ + "static/media/Logo.0b16aaab.jpg";